export enum ActionDescriptionResponseType {
  None = 0,
  Json = 1,
  Blob = 2,
}
